
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire34b5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire34b5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hwrhg", function(module, exports) {
$parcel$export(module.exports, "register", function () { return $cc1a958bd304f822$export$6503ec6e8aabbaf; }, function (v) { return $cc1a958bd304f822$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $cc1a958bd304f822$export$f7ad0328861e2f03; }, function (v) { return $cc1a958bd304f822$export$f7ad0328861e2f03 = v; });
var $cc1a958bd304f822$export$6503ec6e8aabbaf;
var $cc1a958bd304f822$export$f7ad0328861e2f03;
"use strict";
var $cc1a958bd304f822$var$mapping = new Map();
function $cc1a958bd304f822$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$cc1a958bd304f822$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $cc1a958bd304f822$var$resolve(id) {
    var resolved = $cc1a958bd304f822$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$cc1a958bd304f822$export$6503ec6e8aabbaf = $cc1a958bd304f822$var$register;
$cc1a958bd304f822$export$f7ad0328861e2f03 = $cc1a958bd304f822$var$resolve;

});

var $51d476eea371501e$exports = {};

(parcelRequire("hwrhg")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"kLJTI\",\"index.8886a2a4.js\",\"748A0\",\"sign-up-layout-container.09d06caa.js\",\"cSkry\",\"google-logo.5867462c.svg\",\"acWCC\",\"microsoft-logo.c73d8dca.svg\",\"bFVA4\",\"language-selector.139729d8.js\",\"cle9L\",\"dropdown-import.1282cd9b.js\",\"4sqCM\",\"sign-up-layout-container.fdbc2693.js\",\"cOEDe\",\"sign-up-layout-container.e3a0c208.js\",\"30VzF\",\"esm.44a02c99.js\",\"17kbU\",\"confirmationBackgroundV2.dark.7c389c39.png\",\"4up4G\",\"confirmationBackgroundV2.light.74baa5b8.png\",\"2uYAD\",\"confirmationVisual.dark.8d6f446c.svg\",\"5ev77\",\"confirmationVisual.light.d51abd88.svg\",\"j4vAr\",\"teamworkCollectionHeaderV2.dark.88afbace.png\",\"bhrd4\",\"teamworkCollectionHeaderV2.light.d5af8710.png\",\"luJkd\",\"confirmationVisualLoomHasConfluence.dark.4e3c076d.png\",\"8DdY6\",\"confirmationVisualLoomHasConfluence.light.d0fc5a24.png\",\"hqJ2p\",\"confirmationVisualLoomHasConfluenceJira.curlyArrow.1011dffe.png\",\"4ya6N\",\"confirmationVisualLoomHasConfluenceJira.dark.658762d1.png\",\"a774m\",\"confirmationVisualLoomHasConfluenceJira.light.cfa23e42.png\",\"60NR7\",\"controls.ede2b11c.svg\",\"goj9g\",\"teamworkCollectionHeaderLoom.dark.df7c529b.svg\",\"jSINt\",\"teamworkCollectionHeaderLoom.light.5c1dd917.svg\",\"6mNMi\",\"warning.f5011eb7.png\",\"lJwdU\",\"app-tiles.dark.8e97838c.png\",\"fbXgO\",\"app-tiles.light.c0171e78.png\",\"MlCFM\",\"normalizeSeatBackground.dark.3ce9cef1.png\",\"5ouoV\",\"normalizeSeatBackground.light.c079ea47.png\",\"ebGqZ\",\"provisioning.light.716118de.js\",\"2LLAp\",\"provisioning.dark.9b24f1ce.js\",\"2F7rs\",\"icons.light.2f7e80c1.js\",\"ecXve\",\"icons.dark.3ac03991.js\",\"mxYIO\",\"welcome-animation-light.faff5dd0.js\",\"6MglH\",\"welcome-animation-dark.b994352c.js\",\"fuy2l\",\"cs.443e2c1d.js\",\"i4MjO\",\"da.7bbea049.js\",\"hoYtp\",\"de.ef19f5af.js\",\"efo4V\",\"en.d8d267e8.js\",\"dWEC5\",\"en_GB.54cb1afe.js\",\"85QVk\",\"en_ZZ.e7c90699.js\",\"a97Iw\",\"es.ef459366.js\",\"4EQvs\",\"fi.e01576e6.js\",\"bqPR4\",\"fr.aa23096b.js\",\"29H5h\",\"hr.6aa715f5.js\",\"4a0Rz\",\"hu.7a5479cf.js\",\"2xDCd\",\"it.40d1993e.js\",\"koIm7\",\"ja.7cc72dd6.js\",\"l7YsX\",\"ko.543e4098.js\",\"gBR9L\",\"nb.7a554b09.js\",\"lCBzk\",\"nl.3820f566.js\",\"7Z4Rk\",\"pl.64a7cab4.js\",\"dNV56\",\"pt_BR.52a8d08f.js\",\"2xmdz\",\"ru.70d75c06.js\",\"i6aqi\",\"sl.526c9e43.js\",\"iXfgg\",\"sr_RS.d766161a.js\",\"VBydP\",\"sr_YR.6af10fca.js\",\"fF2TF\",\"sv.1a5883c5.js\",\"2vRca\",\"th.bceabe74.js\",\"998a6\",\"tr.ea321bd2.js\",\"dhgvz\",\"uk.d65d88f2.js\",\"2oEn9\",\"vi.889841d4.js\",\"7yl54\",\"zh.d977f23f.js\",\"6GOHf\",\"zh_TW.49f45619.js\",\"dvKsH\",\"animation-illustration.14174c19.js\",\"aitqo\",\"animation-illustration.a9145d1a.js\",\"3HxAa\",\"esm.9c567fa3.js\",\"kY8TR\",\"esm.a008807c.js\",\"41vvP\",\"esm.ec0877cf.js\",\"hnlQ4\",\"esm.2a95a733.js\"]"));


//# sourceMappingURL=index.runtime.b802b05b.js.map
